import React, { useEffect, useState } from 'react';
import { initializeAmplitude } from '../../lib/amplitude/amplitude';
import { useInitializeErrorTracking } from '../../lib/analytics/error-tracking';
import { initializeProductFruits } from '../../lib/product-fruits';
import { useFeatureFlag } from '../../components/utils/use-feature-flag';
import { PropTypes } from 'prop-types';

const propTypes = {
  user: PropTypes.object,
  ready: PropTypes.bool,
};

export const GlobalInitializer = (props) => {
  const [initializeErrorTracking] = useInitializeErrorTracking();

  const esfDemoFF = useFeatureFlag('esf-demo');

  useInitialize(props, initializeAmplitude);
  useInitialize(props, initializeErrorTracking);

  useInitialize(props, (user) => {
    if (!esfDemoFF.isLoading) {
      initializeProductFruits(window, user, esfDemoFF);
      return true;
    }

    return false;
  });

  return <></>;
};

const UNINITIALIZED_USER_ID = null;
const UNAUTHENTICATED_USER_ID = undefined;

const useInitialize = (userReadiness, initializeFn) => {
  const { user, ready } = userReadiness;
  const [initializedUserId, setInitializedUserId] = useState(UNINITIALIZED_USER_ID);

  useEffect(() => {
    setInitializedUserId((prevUserId) => {
      if (!ready) {
        return prevUserId;
      }

      const userId = user?._id ?? UNAUTHENTICATED_USER_ID;

      if (prevUserId === userId) {
        return prevUserId;
      }

      if (initializeFn(user) === false) {
        return prevUserId;
      }

      return userId;
    });
  }, [user, ready, initializeFn]);

  return (user?._id ?? UNAUTHENTICATED_USER_ID) === initializedUserId;
};

GlobalInitializer.propTypes = propTypes;
